(function(){
  'use strict';
  var r=matchMedia('(prefers-reduced-motion:reduce)').matches;
  var n=document.querySelector('.nav');
  if(n)addEventListener('scroll',function(){n.classList.toggle('nav--solid',scrollY>60)},{passive:true});
  var b=document.querySelector('.nav__burger'),m=document.querySelector('.mob'),x=document.querySelector('.mob__x');
  function cl(){if(m)m.classList.remove('open');document.body.style.overflow=''}
  if(b&&m){b.onclick=function(){m.classList.add('open');document.body.style.overflow='hidden'}}
  if(x)x.onclick=cl;
  if(m)m.querySelectorAll('a').forEach(function(a){a.onclick=cl});
  document.onkeydown=function(e){if(e.key==='Escape')cl()};
  function showAll(root){(root||document).querySelectorAll('[data-a]').forEach(function(el){el.classList.add('v')})}
  if(window.Shopify&&Shopify.designMode){
    showAll();
    document.addEventListener('shopify:section:load',function(e){
      var id=e.detail&&e.detail.sectionId;
      var c=id?document.getElementById('shopify-section-'+id):null;
      showAll(c);
      showAll();
    });
  }else if(!r&&'IntersectionObserver'in window){
    var io=new IntersectionObserver(function(e){e.forEach(function(en){if(en.isIntersecting){en.target.classList.add('v');io.unobserve(en.target)}})},{threshold:.1,rootMargin:'0px 0px -30px 0px'});
    document.querySelectorAll('[data-a]').forEach(function(el){io.observe(el)});
  }else showAll();

  /* --- Parallax --- */
  if(!r){
    var pxEls=document.querySelectorAll('[data-parallax]');
    if(pxEls.length){
      var ticking=false;
      function doPx(){
        pxEls.forEach(function(el){
          var rect=el.getBoundingClientRect();
          var speed=parseFloat(el.dataset.parallax)||0.1;
          var center=rect.top+rect.height/2;
          var offset=(center-innerHeight/2)*speed;
          /* Move the whole element for overlaps and floating cards */
          if(el.classList.contains('pov__front')){
            el.style.transform='translate(-50%,calc(-50% + '+offset+'px))';
          }else if(el.classList.contains('wohnen__img--overlap')||el.classList.contains('product-overlay__card')){
            el.style.transform='translate3d(0,'+offset+'px,0)';
          }else{
            var img=el.querySelector('img');
            if(img) img.style.transform='translate3d(0,'+offset+'px,0)';
          }
        });
        ticking=false;
      }
      addEventListener('scroll',function(){
        if(!ticking){requestAnimationFrame(doPx);ticking=true}
      },{passive:true});
      doPx();
    }
  }
})();
